import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Calendar, Users, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-24 pb-16 md:pt-28 md:pb-24 px-4 relative overflow-hidden" data-id="element-181">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-182" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center lg:text-left" data-id="element-184">
          <div className="inline-block px-4 py-1.5 rounded-full bg-brand-gold/10 border border-brand-gold/20 text-brand-gold font-medium text-sm mb-6" data-id="element-185">
            El sistema N°1 en Argentina 🇦🇷
          </div>

          <h1 className="md:text-5xl lg:text-6xl font-bold mb-6 text-[30px]" data-id="element-186">
            Todo lo que comés esta semana. <br data-id="element-187" />
            <span className="text-brand-gold" data-id="element-188">Resuelto. Desde hoy.</span>
          </h1>

          <p className="md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0 text-[18px]" data-id="element-189">
            El sistema definitivo para resolver la comida diaria. Menú + recetas
            + organización listos para usar. Sin improvisar. Sin perder
            domingos.
          </p>

          <div className="grid grid-cols-2 mb-10 text-sm md:text-base text-gray-300 gap-[1px]" data-id="element-190">
            <div className="flex items-center gap-2 justify-center lg:justify-start" data-id="element-191">
              <FileText className="w-5 h-5 text-brand-gold" data-id="element-192" />
              <span data-id="element-193">100% PDF Digital</span>
            </div>
            <div className="flex items-center gap-2 justify-center lg:justify-start" data-id="element-194">
              <Zap className="w-5 h-5 text-brand-gold" data-id="element-195" />
              <span data-id="element-196">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-2 justify-center lg:justify-start" data-id="element-197">
              <Calendar className="w-5 h-5 text-brand-gold" data-id="element-198" />
              <span data-id="element-199">Lunes → Domingo</span>
            </div>
            <div className="flex items-center gap-2 justify-center lg:justify-start" data-id="element-200">
              <Users className="w-5 h-5 text-brand-gold" data-id="element-201" />
              <span data-id="element-202">Toda la familia</span>
            </div>
          </div>

          <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-203">
            <Button size="xl" fullWidth className="max-w-md" onClick={scrollToPricing} data-id="element-204">
              <span className="mr-2 text-2xl" data-id="element-205">🔴</span> QUIERO MI PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-xs text-gray-400 mt-2" data-id="element-206">
              <div className="flex items-center gap-1" data-id="element-207">
                <ShieldCheck className="w-4 h-4" data-id="element-208" /> Garantía 7 días
              </div>
              <div className="flex items-center gap-1" data-id="element-209">
                <Lock className="w-4 h-4" data-id="element-210" /> Pago seguro
              </div>
              <div className="flex items-center gap-1" data-id="element-211">
                <CreditCard className="w-4 h-4" data-id="element-212" /> Mercado Pago
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-213">
          <div className="relative w-full max-w-lg mx-auto aspect-square" data-id="element-214">
            <img src="https://cdn.magicpatterns.com/uploads/cordKNBaW8FAttCewdzGNn/diseno_2.png" alt="Pack Qué Comemos Hoy - Bibliotecas Digitales" className="w-full h-full object-contain drop-shadow-[0_20px_50px_rgba(212,160,23,0.2)]" data-id="element-215" />
          </div>
        </motion.div>
      </div>
    </section>;
}